import styled from "styled-components";
import { Column, ContentContainer, StyledScreen, StyledCta } from "../styles";
import ErrorImage from "../../assets/404-not-found.svg";
import Image from "next/image";
import { MOBILE_BREAKPOINT } from "../../constants";
import { useRouter } from "next/router";
import { Routes } from "../../routes";

const CenteredColumn = styled(Column)`
  margin-top: 12px;
  align-content: center;
  height: 100%;
  align-items: center;
`;

const CTA = styled(StyledCta)`
  margin-bottom: 140px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-bottom: 40px;
  }
`;

const Title = styled.div`
  font-size: ${(props) => props.theme.fontSize.title};
  color: ${(props) => props.theme.colors.text.primary};
  margin-top: 24px;
  font-weight: 500;
  text-align: center;
`;

const Body = styled.div`
  font-size: ${(props) => props.theme.fontSize.regular};
  color: ${(props) => props.theme.colors.text.primary};
  margin-top: 24px;
  text-align: center;
  max-width: 450px;
  line-height: 25px;
`;

const FormErrorView = () => {
  const router = useRouter();

  const onCTAClick = () => {
    router.push(Routes.Landing);
  };

  return (
    <StyledScreen>
      <ContentContainer>
        <CenteredColumn>
          <CTA onClick={onCTAClick}>Powered by Crypto Forms</CTA>
          <Image src={ErrorImage} height={650} />
          <Title>Form not found!</Title>
          <Body>
            We couldn&#39;t find the form you were looking form. Make sure the
            url is correct and try again.
          </Body>
        </CenteredColumn>
      </ContentContainer>
    </StyledScreen>
  );
};

export { FormErrorView };
